import React, { useEffect, useState } from "react"
import { FlatList, ScrollView, View, Image, ActivityIndicator } from "react-native"
import { Icon } from "react-native-elements"
import { useDispatch, useSelector } from "react-redux"
import Colors from "../../constants/Colorsv2"
import { Text, TouchableOpacity } from "../../globalComponents/NativeOverrides"
import { event_getEventByEventId, event_getMatchByMatchId, event_getTournamentByTournamentId } from "../../store/actionsv1/events"
import { market_getHedgesByPlayerId } from "../../store/actionsv1/markets"
import { PublicPlayerProps } from "../../store/types/auth_svc"
import { HedgeProps, MarketProps, OrderProps } from "../../store/types/mk_svc"
import { EventProps, LeagueProps, MatchProps, TournamentProps } from "../../store/types/sr_svc"
import { hedge_getHedgesFromPositions } from "../Home/helpers/hedges"
import EventInfoCard from "./components/EventInfoCard"
import MatchInfoCard from "./components/MatchInfoCard"
import TournamentInfoCard from "./components/TournamentInfoCard"


const EventHedgesScreen = ({ navigation, route }:any) => {
    const [ loading, setLoading ] = useState(false)

    const dispatch = useDispatch();
    const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const market_type:string = useSelector((state:any) => state.auth.market_type, (left, right) => left == right)
    const hedges_state:{updated:number, hedges:HedgeProps[]} = useSelector((state:any) => state.player.hedges, (left, right) => left.updated == right.updated)
    const hedges = hedges_state.hedges.filter(h => h.market_type === market_type && h.event_id == route.params.event_id && h.event_type == route.params.event_type && h.status == 'pending' )
    const markets:MarketProps[] = useSelector((state:any) => state.market.markets, (left, right) => left.length == right.lenth)
    const event:EventProps | undefined = useSelector((state:any) => state.event.events[route.params.event_id], (left, right) => left?.time_detail == right?.time_detail)
    const tournament:TournamentProps | undefined = useSelector((state:any) => state.event.tournaments[route.params.event_id], (left, right) => left?.tournament_id == right?.tournament_id)
    const match:MatchProps | undefined = useSelector((state:any) => state.event.matches[route.params.event_id], (left, right) => left?.match_id == right?.match_id)
    const leagues:LeagueProps[] = useSelector((state:any) => state.event.leagues, (left, right) => left.length == right.length)
    useEffect(() => {
        if(!route.params.event_id || !route.params.event_type){ return }
        getHedgesFromServer(route.params.event_id, route.params.event_type)
    },[route.params.event_id, route.params.event_type])

    const getHedgesFromServer = async(event_id:string, event_type:string) => {
        if(!player){ return }
        setLoading(true)
        await dispatch(market_getHedgesByPlayerId(player.player_id, event_id, event_type))
        if(route.params.event_type === 'team' && !event){ return await dispatch(event_getEventByEventId(route.params.event_id)) }
        if(route.params.event_type === 'tournament' && !tournament){ return await dispatch(event_getTournamentByTournamentId(route.params.event_id)) }
        if(route.params.event_type === 'match' && !match){ console.log('getting match!'); return await dispatch(event_getMatchByMatchId(route.params.event_id)) }
        setLoading(false)
    }

    const renderHedges = (data: {item: HedgeProps, index:number }) => {
        const market = markets.find(m => m.market_id == data.item.market_id)
        let hedge_type = 'positive'
        if(data.item.delayed_cash_draw > 0){
            hedge_type = 'negative'
        }
        if(!market){ return <></> }
        return (
            <TouchableOpacity style={{ margin:10, padding:10, borderRadius:8, borderWidth:1, borderColor:Colors.shades.shade100 }} onPress={() => navigation.push('Hedge', { hedge_id: data.item.hedge_id })}>
                <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'space-between' }}>
                    <Text size={18} color={Colors.brand.midnight} weight='bold'>{market?.description}</Text>
                    <View style={{ borderRadius:20, padding:2, paddingRight:10, paddingLeft:10, backgroundColor:hedge_type == 'positive' ? Colors.utility.success : Colors.utility.warning }}>
                        <Text size={12} color={Colors.shades.white} weight='semibold' textAlign="center">{hedge_type.toUpperCase()}</Text>
                    </View>
                </View>
                <View style={{ flexDirection:'row', justifyContent:'space-between', marginTop:10 }}>
                    <View style={{}}>
                        <Text size={14} color={Colors.brand.midnight} weight='regular'>Hedge Positions</Text>
                        <Text style={{ marginTop:5 }} size={14} color={Colors.brand.midnight} weight='bold'>{data.item.hedged_positions?.length}</Text>
                    </View>
                    <View style={{}}>
                        <Text size={14} color={Colors.brand.midnight} weight='regular' textAlign="right">Cash Out Available</Text>
                        <Text style={{ marginTop:5 }} size={18} color={Colors.highlights.highlight400} weight='bold' textAlign='right'>${data.item.cash_rcvd.toFixed(2)}</Text>
                    </View>
                </View>
                
            </TouchableOpacity>
        )
    }

    return (
        <View style={{ flex:1 }}>
            <ScrollView style={{ flex:1, backgroundColor:Colors.shades.white }}>
                <View nativeID='info-header' style={{ padding:10, paddingTop:0 }}>
                    {route.params.event_type === 'team' && event ?
                    <EventInfoCard event={event} league={leagues.find(l => l.league_id == event.league_id)}/>
                    :<></>}
                    {route.params.event_type === 'tournament' && tournament ?
                    <TournamentInfoCard tournament={tournament} league={leagues.find(l => l.league_id == tournament.league_id)}/>
                    :<></>}
                    {route.params.event_type === 'match' && match ?
                    <MatchInfoCard match={match} league={leagues.find(l => l.league_id == match?.tournament?.league_id)} tournament={match?.tournament}/>
                    :<></>}
                    <Image style={{alignSelf:'center', height:1, width:355, marginTop:10, marginBottom:10}} source={require('../../assets/images/faded_line.png')} />
                </View>
                <View nativeID="event_hedges" style={{ padding:10 }}>
                    <Text size={18} color={Colors.brand.midnight} weight='bold' textAlign="center">PENDING HEDGES</Text>
                </View>
                <FlatList data={hedges} renderItem={renderHedges} keyExtractor={(item) => item.hedge_id.toString()}/>
                {loading ?
                <View style={{ justifyContent:'center', alignItems:'center', padding:10 }}>
                    <ActivityIndicator size='large' color={Colors.brand.midnight} />
                </View>
                :<></>}
            </ScrollView>
            <TouchableOpacity nativeID="hedge_info" style={{ padding:10, backgroundColor:Colors.highlights.highlight200Faded, justifyContent:'center', alignItems:'center' }} onPress={() => window.open('https://support.bettoredge.com/hc/en-us/articles/9683385953047-What-are-hedged-positions', '_blank')}>
                <Icon name='alert-circle' type='feather' color={Colors.brand.electric} size={18} />
                <Text color={Colors.brand.electric} size={14} weight='regular'>What is a Hedge?</Text>
            </TouchableOpacity>
        </View>
    )
}

export default EventHedgesScreen